import {
	Button,
	Group,
	Popover,
	PopoverTrigger,
	SkeletonRect,
	Stack,
} from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { StatBox } from '@common/components/StatBox';
import { formatCurrency } from '@common/lib/currency';

import { useGetOrderPaymentFai } from '../../api/useGetOrderPaymentFai';
import { TransactionList } from '../order-payment/TransactionList';

import { PaymentStatusTag } from './shared/PaymentStatusTag';

interface PaymentCellProps {
	status?: string;
	purchasedVehicleId: string;
}

const PopoverContent = ({ purchasedVehicleId }: { purchasedVehicleId: string }) => {
	const { data: orderPaymentFai, isLoading } = useGetOrderPaymentFai(purchasedVehicleId);

	const buyerPayments = orderPaymentFai?.buyerPayments;
	const paid = buyerPayments?.paid;
	const balance = buyerPayments?.balance;
	const transactions = buyerPayments?.transactions;

	return (
		<div style={{ width: 360 }}>
			<Stack itemsSpacing='8'>
				{isLoading ? (
					<SkeletonRect width='100%' height={120} />
				) : (
					<Stack itemsSpacing='8'>
						{paid !== undefined && balance !== undefined && (
							<Group itemsSpacing='16' noWrap itemsAlignX='stretch'>
								<StatBox title='Paid' detail={formatCurrency(paid)} />
								<StatBox title='Balance' detail={formatCurrency(balance)} />
							</Group>
						)}

						<TransactionList
							transactions={transactions}
							totalLabel='Total transactions'
							emptyMessage='No transactions for this order'
							includeTotal={false}
						/>
					</Stack>
				)}
			</Stack>
		</div>
	);
};

export const PaymentCell = ({ status, purchasedVehicleId }: PaymentCellProps) => {
	// PopoverContent only renders when popover is open, so the hook will only be called then
	return (
		<PopoverTrigger>
			<Button
				className='payment-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<PaymentStatusTag status={status} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent purchasedVehicleId={purchasedVehicleId} />
			</Popover>
		</PopoverTrigger>
	);
};
